import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ListingsCalendar } from '../components/ListingsCalendar'
import {
  actionCreators,
  IListingsCalendarState,
  selectDownloadUrl,
  selectEndTime,
  selectError,
  selectEvents,
  selectIsLoading,
  selectScope,
  selectStartTime,
} from '../modules/listingsCalendar'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IListingsCalendarState & ICurrentUserState
  >({
    downloadUrl: selectDownloadUrl(),
    endTime: selectEndTime(),
    error: selectError(),
    events: selectEvents(),
    isLoading: selectIsLoading(),
    scope: selectScope(),
    startTime: selectStartTime(),
    user: selectCurrentUser(),
  }),
  actionCreators,
)(ListingsCalendar)
